const constants = {
  m4uUrl: process.env.VUE_APP_M4U_URL || 'https://tim.com.br',
};

export default constants;
